import React, { useEffect, useState, useRef } from "react";
import { ProjectAPI } from "../api/apiClient";
import { useUI } from "../context/UIContext";

// Issue type
type Issue = {
  taskId: number;
  title: string;
  dueDate?: string;
  status?: string;
  taskGroupName?: string;
};

export default function AllIssues() {
  const {
    selectedProjectId,
    setSelectedIssueId,
    setSelectedIssueTitle,
    setViewMode,
    pushUIState,
    allIssuesFilters,
    
    setAllIssuesFilters,
  } = useUI();

  //const { status, taskGroup, fromDue, toDue } = allIssuesFilters;
  const { status, taskGroup, fromDue, toDue } =
  allIssuesFilters ?? {
    status: "",
    taskGroup: "",
    fromDue: "",
    toDue: "",
  };


  const [issues, setIssues] = useState<Issue[]>([]);
  const [taskGroups, setTaskGroups] = useState<
    { taskGroupNo: number; taskGroupName: string }[]
  >([]);

  // ✅ PUSH BASE STATE ONLY ONCE
  const hasPushedBase = useRef(false);

  useEffect(() => {
    if (hasPushedBase.current) return;
    pushUIState(); // snapshot: All Issues (NO filters)
    hasPushedBase.current = true;
  }, [pushUIState]);

  // ✅ Load task groups
  useEffect(() => {
    if (!selectedProjectId) return;

    ProjectAPI.getTaskGroups(selectedProjectId)
      .then(setTaskGroups)
      .catch(console.error);
  }, [selectedProjectId]);

  // ✅ Load issues whenever filters change
  useEffect(() => {
    if (!selectedProjectId) return;
    load(selectedProjectId);
  }, [selectedProjectId, status, taskGroup, fromDue, toDue]);

  async function load(projectId: number) {
    const params = new URLSearchParams();

    if (status) params.append("status", status);
    if (taskGroup) params.append("taskGroup", taskGroup);
    if (fromDue) params.append("fromDue", fromDue);
    if (toDue) params.append("toDue", toDue);

    const data = await ProjectAPI.getAllIssues(projectId, params);
    setIssues(Array.isArray(data) ? data : []);
  }

   /* async function load(projectId: number) {
  let params: URLSearchParams | null = null;

  // ✅ ONLY create params if filters exist
  if (status || taskGroup || fromDue || toDue) {
    params = new URLSearchParams();

    if (status) params.append("status", status);
    if (taskGroup) params.append("taskGroup", taskGroup);
    if (fromDue) params.append("fromDue", fromDue);
    if (toDue) params.append("toDue", toDue);
  }

  const data = await ProjectAPI.getAllIssues(projectId, params);
  setIssues(Array.isArray(data) ? data : []);
}
*/
  function openIssue(issue: Issue) {
    pushUIState(); // snapshot before navigating
    setSelectedIssueId(issue.taskId);
    setSelectedIssueTitle(issue.title);
    setViewMode("issue-chat");
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">All Issues</h2>

      {/* Filters */}
      <div className="grid grid-cols-4 gap-3 mb-4">
        <select
          value={status}
          onChange={(e) =>
            setAllIssuesFilters((f) => ({ ...f, status: e.target.value }))
          }
          className="border p-2 rounded"
        >
          <option value="">All Statuses</option>
          <option value="Open">Open</option>
          <option value="Closed">Closed</option>
          <option value="Hold">Hold</option>
          <option value="Archive">Archive</option>
        </select>

        <select
          value={taskGroup}
          onChange={(e) =>
            setAllIssuesFilters((f) => ({ ...f, taskGroup: e.target.value }))
          }
          className="border p-2 rounded"
        >
          <option value="">All Task Groups</option>
          {taskGroups.map((g) => (
            <option key={g.taskGroupNo} value={g.taskGroupNo}>
              {g.taskGroupName}
            </option>
          ))}
        </select>

        <input
          type="date"  
          className="border p-2 rounded"
          value={fromDue}
          onChange={(e) =>
            setAllIssuesFilters((f) => ({ ...f, fromDue: e.target.value }))
          }
        />

        <input
          type="date"
          className="border p-2 rounded"
          value={toDue}
          onChange={(e) =>
            setAllIssuesFilters((f) => ({ ...f, toDue: e.target.value }))
          }
        />
      </div>
 
      {/* Issue List */}
      <div className="space-y-3">
        {issues.map((iss) => (
          <div
            key={iss.taskId}
            className="p-3 border rounded hover:bg-gray-100 cursor-pointer"
            //onClick={() => openIssue(iss)}
          >
            <div className="font-semibold">{iss.title}</div>

            {iss.taskGroupName && (
              <div className="text-sm text-gray-500">
                {iss.taskGroupName}
              </div>
            )}

            <div className="text-xs text-gray-500">
              Due:{" "}
              {iss.dueDate
                ? new Date(iss.dueDate).toLocaleDateString()
                : "No date"}
                </div>

                {/*details chat button */}
                 {/* 🔘 ADD BUTTONS HERE */} 
                <div className="flex gap-2">
                <button
                className="px-3 py-1 text-sm bg-blue-600 text-white rounded"
                onClick={() => {
                   pushUIState();
                   setSelectedIssueId(iss.taskId);
                  setSelectedIssueTitle(iss.title);
                   setViewMode("issue-details");
               }}
               >
             📄 Details
            </button>

           <button
            className="px-3 py-1 text-sm bg-gray-700 text-white rounded"
            onClick={() => {
            pushUIState();
            setSelectedIssueId(iss.taskId);
            setSelectedIssueTitle(iss.title);
            setViewMode("issue-chat");
            }}
            >
            💬 Chat
           </button>


            </div>
          </div>
        ))}
      </div>
    </div>
  );
}